import React from 'react';

import { appMethod as app } from '@utils/app';
import { pageInstance } from '@utils/page';
import util from '@utils/util';

import { transformPx2Rem, convertStyleData } from '@utils/tools';

import './FranchiseeChainCustomComponent.less';

const stringLength = function(str) {
  var len = 0;
  for (var i = 0; i < str.length; i++) {
    var a = str.charCodeAt(i);;
    if (a >= 0 && a <= 128) {
      len += 1;
    }else{
      len += 2;
    }
  }
  return len;
}

const isEllipsis = function(str, max){
  var strLength = stringLength(str);
  return strLength > max;
}

/**
 * type: "franchisee-chain" 
 * 组件：连锁多商家组件
 * 
 * TODO: 目前未写接口请求店铺及子店数据
 */

export default class FranchiseeChainCustomComponent extends React.Component {
  
  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance, isPullRefresh) => {
    if (isPullRefresh) {
      return;
    }
    let data = pageInstance.data;
    if (pageInstance.hasChain) {
      return;
    }
    pageInstance.hasChain = true;
    let chainStore = app.globalData.chainAppId;
    if (chainStore) {
      this.getChainStoreInfo();
    } else {
      this.getMainStoreInfo();
    }
  }

  getMainStoreInfo = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopInfo',
      data: {
      },
      success: function (res) {
        let newdata = {};
        let data = res.data;
        if (!data.app_id) {
          return;
        }
        let pageInstance = app.getAppCurrentPage();
        let inBusiness = app.businessTimeCompare(data.business_time || []);
        pageInstance.setData({
          currentChainStore: {
            name: data.name,
            phone: data.phone,
            address: data.province_name + data.city_name + data.county_name + data.address_detail,
            not_business: !inBusiness,
            is_open: data.is_open
          }
        })
      }
    })
  }

  getChainStoreInfo = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: {
        is_show_chain: 1,
        sub_shop_app_id: app.globalData.chainAppId,
        page: 1,
        page_size: 1
      },
      success: function (res) {
        that.setChainInfo(res);
      },
      fail: function(){
        let pageInstance = app.getAppCurrentPage();
        app.globalData.chainAppId = '';
        app.globalData.chainHistoryDataId = '';
        if (pageInstance && pageInstance.page_router && app.globalData.chainNotLoading && pageInstance.dataInitial) {
          pageInstance.dataInitial();
        }
        app.globalData.chainNotLoading = false;
      }
    })
  }

  getNearbyChainInfo = (param, pageIns) => {
    let that = this;
    let pageInstance = pageIns || app.getAppCurrentPage();
    app.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: {
        is_show_chain: 1,
        sort_key: 'distance',
        sort_direction: 1,
        online_his_id: app.globalData.historyDataId,
        latitude: param.latitude,
        longitude: param.longitude,
        page: 1,
        page_size: 1
      },
      success: function (res) {
        that.setChainInfo(res);
      },
      fail: function(){
        app.globalData.chainAppId = '';
        app.globalData.chainHistoryDataId = '';
        if (pageInstance && pageInstance.page_router && app.globalData.chainNotLoading && pageInstance.dataInitial) {
          pageInstance.dataInitial();
        }
        app.globalData.chainNotLoading = false;
      },
      complete: function(){
        wx.hideLoading();
      }
    })
  }

  setChainInfo = (res, _from) => {
    let that = this;
    let newdata = {};
    let data = res.data[0];
    let pageInstance = app.getAppCurrentPage();

    if (!data || app.globalData.historyDataId != data.s_his_data.online_his_id){
      if (_from === 'fromWxCode') {
        app.showModal({
          title: '提示',
          content: '连锁子店版本与线上版本不一致，将回到总店'
        });
      }
      app.globalData.chainAppId = '';
      app.globalData.chainHistoryDataId = '';
      if (pageInstance && pageInstance.page_router && app.globalData.chainNotLoading && pageInstance.dataInitial) {
        pageInstance.dataInitial();
      }
      app.globalData.chainNotLoading = false;
      return;
    }
    let inBusiness = app.businessTimeCompare(data.business_time || []);
    app.globalData.chainHistoryDataId = data.s_his_data.his_id;
    if (app.globalData.chainNotLoading) {
      app.globalData.chainAppId = data.app_id;
    }
    if (pageInstance && pageInstance.page_router) {
      pageInstance.setData({
        currentChainStore: {
          name: data.name,
          phone: data.phone,
          address: data.province_name + data.city_name + data.county_name + data.address_detail,
          not_business: !inBusiness,
          is_open: data.is_open
        }
      });
      if (app.globalData.chainNotLoading && pageInstance.dataInitial) {
        pageInstance.dataInitial();
      }
    }
    app.globalData.chainNotLoading = false;
  }

  turnToChainStoreList = (e) => {
    let compindex = e.currentTarget.dataset.compindex;
    let pageInstance = app.getAppCurrentPage();
    let customFeature = pageInstance.data.eles[compindex].customFeature;
    let param = '';

    if (customFeature.sourceType && customFeature.source){
      param = '?sourceType=' + customFeature.sourceType + '&source=' + customFeature.source;
    }
    app.turnToPage('chainStoreList' + param);
  }

  render() {
    // 组件数据
    const data = this.props.data;
    // 当前连锁店数据
    const currentChainStore = pageInstance.data.currentChainStore || {};
    // 组件配置对象
    const customFeature = data.customFeature;
    const styleObj = convertStyleData(data.style);
    const btnColor = customFeature.buttonColor;
    const titleColor = customFeature.titleColor;
    const infoColor = customFeature.instructionsColor;

    return (
      <div className={`custom-component franchisee-chain mode-${customFeature.mode}`} style={styleObj} data-compindex={this.props.index} onClick={this.turnToChainStoreList}>
        {
          customFeature.mode == 0 &&
          <React.Fragment>
            <div className="store-current">
              <div className="store-change" style={{
                color: customFeature.buttonColor,
              }}>
                <span>{customFeature.prefixTitle || '换门店'}</span>
                <span className="ico-moon icon-filter-down"></span>
              </div>
              <div className="store-name" style={{
                color: data.customFeature.titleColor
              }}>
                {currentChainStore.name || ''}
              </div>
              {
                currentChainStore.not_business || currentChainStore.is_open == 0 &&
                <div className="store-business" style={{
                  marginLeft: isEllipsis(currentChainStore.name, 24) ? '0' : '.20rem'
                }}>歇业中</div>
              }
            </div>
            <div className="store-info" style={{
              color: customFeature.instructionsColor,
            }}>
              <div className="store-phone">
                <span className="ico-moon icon-takeout-cellphone"></span>
                <span>{currentChainStore.phone || ''}</span>
              </div>
              <div className="store-address">
                <span className="ico-moon icon-community-location"></span>
                <span>{currentChainStore.address || ''}</span>
              </div>
            </div>
          </React.Fragment>
        }
        {
          customFeature.mode == 1 &&
          <React.Fragment>
            <div className="store-current">
              <div className="store-change" style={{
                color: customFeature.buttonColor,
              }}>
                <span>{customFeature.prefixTitle || '换门店'}</span>
                <span className="ico-moon icon-filter-down"></span>
              </div>
              <div className="store-name" style={{
                color: data.customFeature.titleColor
              }}>
                {currentChainStore.name || ''}
              </div>
              {
                currentChainStore.not_business || currentChainStore.is_open == 0 &&
                <div className="store-business" style={{
                  marginLeft: isEllipsis(currentChainStore.name, 24) ? '0' : '.20rem'
                }}>歇业中</div>
              }
            </div>
          </React.Fragment>
        }
        {
          customFeature.mode == 2 &&
          <React.Fragment>
            <div className="store-current">
              <div className="store-name" style={{
                color: data.customFeature.titleColor
              }}>
                <span className="ico-moon icon-community-location" style={{
                  color: customFeature.buttonColor,
                }}></span>
                {currentChainStore.name || ''}
              </div>
              {
                currentChainStore.not_business || currentChainStore.is_open == 0 &&
                <div className="store-business" style={{
                  marginLeft: isEllipsis(currentChainStore.name, 24) ? '0' : '.20rem'
                }}>歇业中</div>
              }
            </div>
            <div className="store-search">
              <span className="icon-moon icon-search"></span>
              <span>搜索其他店铺</span>
            </div>
          </React.Fragment>
        }
        {
          customFeature.mode == 3 &&
          <React.Fragment>
            <div className="store-current">
              <div className="store-name" style={{
                color: data.customFeature.titleColor
              }}>
                {currentChainStore.name || ''}
              </div>
              {
                currentChainStore.not_business || currentChainStore.is_open == 0 &&
                <div className="store-business" style={{
                  marginLeft: isEllipsis(currentChainStore.name, 24) ? '0' : '.20rem'
                }}>歇业中</div>
              }
              <div className="store-info" style={{
                color: customFeature.instructionsColor,
              }}>
                <div className="store-phone">
                  <span className="ico-moon icon-takeout-cellphone"></span>
                  <span>{currentChainStore.phone || ''}</span>
                </div>
                <div className="store-address">
                  <span className="ico-moon icon-community-location"></span>
                  <span>{currentChainStore.address || ''}</span>
                </div>
              </div>
            </div>
          </React.Fragment>
        }
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/custom-component/franchisee-chain-custom-component/FranchiseeChainCustomComponent.jsx